import { getRights, type Navbar } from "../services/user";

export type WorkspaceUser = Omit<Navbar["user"], "rights"> & {
  rights: Set<string>;
  account: {
    id: number;
    name: string;
  };
  client: {
    id: string;
    name: string;
  };
};

export function getWorkspaceUser(navbar: Navbar): WorkspaceUser {
  return {
    ...navbar.user,
    rights: getRights(navbar.user.rights ?? {}),
    account: {
      id: +navbar.account.account_id,
      name: navbar.account.account_name,
    },
    client: {
      id: navbar.client.client_id,
      name: navbar.client.client_label,
    },
  };
}
